import React from 'react'

export type TabProps = {
  title: string
  /** Header text; `title` stays the ?tab= key */
  label?: React.ReactNode
  onClick?: () => void
  errors?: string[]
  disabled?: boolean
  canClick?: boolean
  className?: string
  children?: React.ReactNode
}

// A child of <Tabs />; only its props are read
export const Tab = ({ className, children }: TabProps) => (
  <div className={className}>{children}</div>
)
